import {api, headers} from './api';

const RESOURCE = 'pangkat_golongan';

export const indexPangkatGolongan = () => api.get(RESOURCE, headers);